import { Expose, Type } from 'class-transformer'
import { PenNameType } from '@models/penName/PenNameType'

export class MyBookType {
  @Expose() id: number

  @Expose() writer: string

  @Expose() coverImgPath?: string

  @Expose() title: string

  @Type(() => PenNameType)
  penName: PenNameType
}
